import Breadcrumbs from "e.sic-platform.webclient/src/components/navbar/Breadcrumbs";
import LanguageSelector from "e.sic-platform.webclient/src/components/navbar/LanguageSelector";
import {
  NavbarActions,
  NavbarMain,
} from "e.sic-platform.webclient/src/components/navbar/NavbarComponents";
import { observer } from "mobx-react-lite";
import CoinBalance from "./CoinBalance";
import { Divider, Box, useTheme, useMediaQuery } from "@mui/material";
import BreadcrumbItem from "e.sic-platform.webclient/src/components/navbar/BreadcrumbItem";
import UserTag from "./UserTag";
import NavbarMenu from "./NavbarMenu";
import useMenuStorage from "../../services/menu/MenuStorageService";
import ProfileMenu, { AuthenticatedMenu } from "./ProfileMenu";
import { useCallback, useEffect } from "react";
import { PubSubEvents } from "e.sic-platform.webclient/src/services/PubSubEvents";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import { shopHistoryStorage } from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";

export default observer(function Navbar(props: { menuOpen: boolean; setMenuOpen: (menuOpen: boolean) => void }) {
  const {menuCategories} = useMenuStorage();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const reloadServices = useCallback(async () => {
    console.log("Finished")
    await creditBalanceStorage.load();
    await shopHistoryStorage.load();
  }, [])

  const subscribeToEvent = useCallback((event: PubSubEvents) => {
      PubSub.subscribe(event, reloadServices)
  }, [reloadServices])

  useEffect(() => {
    subscribeToEvent(PubSubEvents.VideoConversionFinished);
    subscribeToEvent(PubSubEvents.VideoAnalysisFinished);
    subscribeToEvent(PubSubEvents.VideoSegmentationFinished);
    subscribeToEvent(PubSubEvents.VideoOcrFinished);
  }, [subscribeToEvent])

  return (
    <NavbarMain>
      <Box display="flex" alignItems="center">
        <NavbarMenu menuOpen={props.menuOpen} setMenuOpen={props.setMenuOpen} />
        <Breadcrumbs menuCategories={menuCategories} title={"SmartApps"} />
      </Box>

      <NavbarActions>
        {isSmallScreen ? (
            <ProfileMenu />
        ) : (
          <>
            <BreadcrumbItem to="/shop" textKey="general.shop" />
            <CoinBalance />
            <Divider
              orientation="vertical"
              sx={{ mr: 2, p: 0, borderColor: "white" }}
              flexItem
            />
            <LanguageSelector />
            <Divider
              orientation="vertical"
              sx={{ mr: 2, p: 0, borderColor: "white" }}
              flexItem
            />
            <UserTag />
            <ProfileMenu />
          </>
        )}
      </NavbarActions>
    </NavbarMain>
  );
});
